"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = JumbotronImageSlider;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

require("slick-carousel/slick/slick.css");

require("slick-carousel/slick/slick-theme.css");

require("./JumbotronImageSlider.scss");

var GalleryArrow = function GalleryArrow(_ref) {
  var placement = _ref.placement,
      onClick = _ref.onClick;
  return _react["default"].createElement("div", {
    className: "control ".concat(placement)
  }, _react["default"].createElement("a", {
    onClick: onClick
  }, _react["default"].createElement("div", {
    className: "circle"
  }, _react["default"].createElement("i", {
    className: "icon icon-hg-chev-".concat(placement)
  }))));
};

var settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  nextArrow: _react["default"].createElement(GalleryArrow, {
    placement: "right"
  }),
  prevArrow: _react["default"].createElement(GalleryArrow, {
    placement: "left"
  })
};
var navSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 13,
  slidesToScroll: 1,
  centerMode: true,
  className: "center",
  adaptiveHeight: true,
  nextArrow: _react["default"].createElement(GalleryArrow, {
    placement: "right"
  }),
  prevArrow: _react["default"].createElement(GalleryArrow, {
    placement: "left"
  }),
  responsive: [{
    breakpoint: 1026,
    settings: {
      slidesToShow: 11
    }
  }, {
    breakpoint: 991,
    settings: {
      slidesToShow: 9
    }
  }, {
    breakpoint: 600,
    settings: {
      slidesToShow: 5,
      slidesToScroll: 1
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 5,
      slidesToScroll: 1
    }
  }]
};

var getThumbnailUrl = function getThumbnailUrl(str) {
  return str.replace(/\.jpeg/, '_cs.jpeg');
};

function JumbotronImageSlider(_ref2) {
  var images = _ref2.images,
      uploadedUrls = _ref2.uploadedUrls,
      primaryImageUrl = _ref2.primaryImageUrl,
      customPaging = _ref2.customPaging,
      showNav = _ref2.showNav;
  images = images ? images : [];
  var allImages = uploadedUrls ? [].concat((0, _toConsumableArray2["default"])(uploadedUrls), (0, _toConsumableArray2["default"])(images)) : images;

  var _useState = (0, _react.useState)({
    nav1: null,
    nav2: null
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var slider1 = (0, _react.useRef)();
  var slider2 = (0, _react.useRef)(); // if (customPaging) settings.customPaging = customPaging;

  (0, _react.useEffect)(function () {
    setState({
      nav1: slider1.current,
      nav2: slider2.current
    });
  }, []);
  var nav1 = state.nav1,
      nav2 = state.nav2;
  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_reactSlick["default"], (0, _extends2["default"])({}, settings, {
    className: "gallery ".concat(customPaging ? 'gallery--customPaging' : ''),
    asNavFor: nav2,
    ref: function ref(slider) {
      return slider1.current = slider;
    }
  }), allImages.map(function (image, index) {
    // Return loading if on image
    if (!image) return null;
    return _react["default"].createElement("div", {
      className: "gallery-item",
      key: image
    }, _react["default"].createElement("div", {
      className: "item-wrap"
    }, _react["default"].createElement("img", {
      className: "banner-img",
      src: image
    }), image.caption && _react["default"].createElement("div", {
      className: "gallery-caption"
    }, _react["default"].createElement("p", null, image.caption))));
  })), showNav && _react["default"].createElement(_reactSlick["default"], (0, _extends2["default"])({}, navSettings, {
    asNavFor: nav1,
    className: "gallery-nav",
    focusOnSelect: true,
    ref: function ref(slider) {
      return slider2.current = slider;
    }
  }), allImages.map(function (image) {
    if (!image) return null;
    return _react["default"].createElement("div", {
      className: "gallery-nav-item"
    }, _react["default"].createElement("img", {
      key: image,
      src: getThumbnailUrl(image),
      alt: ""
    }));
  })));
}